import { fmtNum } from "@/lib/format";

const DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const dayLabel = (d) => {
  const [y, m, day] = d.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, day));
  return { dow: DOW[dt.getUTCDay()], md: `${String(m).padStart(2, "0")}-${String(day).padStart(2, "0")}-${String(y).slice(2)}` };
};

const v = (x) => (x === null || x === undefined || x === "" ? "" : fmtNum(x));

export const TimesheetTotals = ({ totals, testId = "timesheet-totals" }) => (
  <div className="grid grid-cols-3 gap-2" data-testid={testId}>
    {[["Total miles", fmtNum(totals.miles), "miles"], ["ATV days", totals.atv_days, "atv"], ["Hours on site", `${fmtNum(totals.hours)}`, "hours"]].map(([l, val, k]) => (
      <div key={k} className="panel p-3">
        <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-slate-500">{l}</p>
        <p className="font-mono-num mt-1 text-2xl font-semibold" data-testid={`${testId}-${k}`}>{val}</p>
      </div>
    ))}
  </div>
);

export const TimesheetTable = ({ rows }) => (
  <div className="overflow-x-auto rounded-lg border border-border" data-testid="timesheet-table">
    <table className="w-full min-w-[560px] text-sm">
      <thead className="bg-slate-50 text-left text-[11px] uppercase tracking-wider text-slate-600">
        <tr><th className="px-3 py-2">Date</th><th className="px-3 py-2">Location</th><th className="px-3 py-2 text-right">Miles</th><th className="px-3 py-2 text-center">ATV</th><th className="px-3 py-2 text-right">Hours</th><th className="px-3 py-2 text-right">Min</th></tr>
      </thead>
      <tbody className="divide-y divide-border">
        {rows.map((r) => {
          const d = dayLabel(r.date);
          return (
            <tr key={r.date} className={d.dow === "Sun" ? "border-t-2 border-slate-300" : ""} data-testid={`timesheet-row-${r.date}`}>
              <td className="whitespace-nowrap px-3 py-2"><span className="font-semibold">{d.dow}</span> <span className="text-slate-600">{d.md}</span></td>
              <td className="px-3 py-2">{r.location}</td>
              <td className="font-mono-num px-3 py-2 text-right">{v(r.miles)}</td>
              <td className="px-3 py-2 text-center">{r.atv ? "Yes" : ""}</td>
              <td className="font-mono-num px-3 py-2 text-right">{v(r.hours)}</td>
              <td className="font-mono-num px-3 py-2 text-right">{v(r.minutes)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
